import { NEWS } from "src/common/constants";
import { NewsAction, NewsItem } from "../reducers/news";
export const NEWS_FETCH_DATA = `${NEWS}_GET_DATA` as const;
export const NEWS_FETCH_INVOKED = `${NEWS}_GET_INVOKED` as const;
export const NEWS_FETCH_SUCCESS = `${NEWS}_GET_SUCCESS` as const;
export const NEWS_FETCH_FAILED = `${NEWS}_GET_FAILED` as const;

export const fetchNews = () => ({ type: NEWS_FETCH_DATA });
export const fetchNewsInvoked = (): NewsAction => ({
  type: NEWS_FETCH_INVOKED,
});
export const fetchNewsSuccess = (payload: NewsItem[]): NewsAction => ({
  type: NEWS_FETCH_SUCCESS,
  payload,
});
export const fetchNewsFailed = (error: Error): NewsAction => ({
  type: NEWS_FETCH_FAILED,
  error,
});
